import {ErrorHandler, Injectable} from '@angular/core';
import {createErrorHandler} from '@sentry/angular';
import {HttpErrorResponse} from '@angular/common/http';
import * as Sentry from "@sentry/browser";

@Injectable({
  providedIn: 'root'
})
export class SentryErrorHandlerService implements ErrorHandler {
  private sentryErrorHandler = createErrorHandler();

  handleError(error: unknown): void {
    if (error instanceof HttpErrorResponse) {
      const err = new Error(`HTTP ${error.status}: ${error.message}`);
      (err as any).originalError = error;
      Sentry.captureException(
        err,
        {
          extra: {
            type: 'HttpErrorResponse',
            responseDetails: error?.error || 'No response details available',
          }
        }
      );
      // this.sentryErrorHandler.handleError(err);
    } else if (error instanceof Error) {
      // this.sentryErrorHandler.handleError(error);
      Sentry.captureException(error,
        {
          extra: {
            type: 'ApplicationError'
          }
        }
        );
    } else if (typeof error === 'string') {
      // this.sentryErrorHandler.handleError(new Error(error));
      Sentry.captureException(new Error(error),
        {
          extra: {
            type: 'StringError'
          }
        }
        );
    } else if (typeof error === 'object' && error !== null) {
      const err = new Error('Non-Error object captured');
      (err as any).extra = error;
      // this.sentryErrorHandler.handleError(err);
      Sentry.captureException(err,
        {
          extra: {
            type: 'NonErrorObjectError'
          }
        }
        );
    } else {
      // this.sentryErrorHandler.handleError(new Error(`Unknown error: ${String(error)}`));
      Sentry.captureException(new Error(`Unknown error: ${String(error)}`),
        {
          extra: {
            type: 'UnknownError'
          }
        }
        );
    }
  }
}
